import { TOGGLE_MENU_CONTEXT, UPDATE_CURRENT_PATIENT } from '../actions/types';
import { Application } from '../models/application';

export default function application(state = Application, action = {}) {
  switch (action.type) {
    case TOGGLE_MENU_CONTEXT:
      return Object.assign({}, state, { currentContext: action.context });
    case UPDATE_CURRENT_PATIENT:
      return Object.assign({}, state, { currentPatient: action.context });
    default:
      return state;
  }
}
